'use client';

import { getCookie } from 'cookies-next/client';
import { useEffect, useState } from 'react';
import { ClientCookies } from '@/core/services/cookie-storage';
import { useCookieStorageContext } from '@/ui/context/cookie-storage';

/** Same-tab login sets the cookie before React re-renders; read synchronously on first paint. */
export function readHasAuthSessionFromBrowser(): boolean {
  if (typeof window === 'undefined') return false;
  const raw = getCookie('hasAuthSession');
  if (raw === undefined || raw === null || raw === '') return false;
  return raw === 'true';
}

const useAuthSession = (): boolean => {
  const storage = useCookieStorageContext();
  const [hasAuthSession, setHasAuthSession] = useState<boolean>(() =>
    readHasAuthSessionFromBrowser(),
  );

  useEffect(() => {
    void storage.get('hasAuthSession').then(value => {
      setHasAuthSession(value ?? readHasAuthSessionFromBrowser());
    });
  }, [storage]);

  useEffect(() => {
    if (typeof window === 'undefined') return undefined;
    return ClientCookies.subscribe('hasAuthSession', value => {
      setHasAuthSession(value ?? readHasAuthSessionFromBrowser());
    });
  }, []);

  return hasAuthSession || readHasAuthSessionFromBrowser();
};

export default useAuthSession;
